import { merge } from 'lodash'
import {
  LOGIN,
  LOGOUT,
  POST_OTP,
  POST_DETAILS,
  VIEW_AS_ADMIN,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  POST_OTP_SUCCESS,
  POST_DETAILS_SUCCESS,
  VIEW_AS_ADMIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_ERROR,
  POST_OTP_ERROR,
  POST_DETAILS_ERROR,
  VIEW_AS_ADMIN_ERROR,
  ADD_EMAIL,
  ADD_EMAIL_SUCCESS,
  ADD_EMAIL_ERROR,
  GET_EMAILS,
  RECEIVE_EMAILS,
  DELETE_EMAIL,
  DELETE_EMAIL_SUCCESS
} from '../actions/login-actions'

export default (state = false, action) => {
  switch (action.type) {
    case LOGIN:
    case LOGOUT:
    case POST_OTP:
    case POST_DETAILS:
    case VIEW_AS_ADMIN:
    case ADD_EMAIL:
    case GET_EMAILS:
    case DELETE_EMAIL:
      return true;
    case DELETE_EMAIL_SUCCESS:
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case POST_OTP_SUCCESS:
    case POST_DETAILS_SUCCESS:
    case VIEW_AS_ADMIN_SUCCESS:
    case LOGIN_ERROR:
    case LOGOUT_ERROR:
    case POST_OTP_ERROR:
    case POST_DETAILS_ERROR:
    case VIEW_AS_ADMIN_ERROR:
    case ADD_EMAIL_SUCCESS:
    case ADD_EMAIL_ERROR:
    case RECEIVE_EMAILS:
      return false;
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/loading.js